<template lang="pug">
  .h-100
    #concepts_chart.h-100
    loader-vue(:visible="loaderVisible")
</template>

<script>
import TirantBarChart from 'common/TirantBarChart'
import ApiClient from 'common/ApiClient'
import filters from 'common/filters'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'bar-chart-vue',
  props: {
    concepts: { type: Array, default: () => [] },
    source: { type: String, default: '' },
    docid: { type: Number, default: 0 },
  },
  components: {
    'loader-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Loader')
  },
  data() {
    return {
      scrLoaded: false,
      scrData: {},
      loaderVisible: false,
      clickedElement: undefined,
      barChart: undefined
    }
  },
  methods: {
    mapTermsToConcepts() {
      this.concepts.forEach(concept => {
        concept.terms = this.scrData[concept.id] || []
      })
    },
    conceptsWithTerms() {
      if (this.source !== 'scr') return this.concepts
      return this.concepts.filter(concept => concept.terms && concept.terms.length > 0)
    },
    countOccurrences(concept) {
      const terms = (concept.terms || []).flatMap(term =>
        term.split('\n').map(s => s.trim()).filter(s => s.length > 1)
      )
      if (!terms.length) return 0

      const allFields = [...(this.headerFields || []), ...(this.bodyFields || [])]
      const paragraphs = allFields.flatMap(section =>
        Array.isArray(section.value) ? section.value : (section.value ? [section.value] : [])
      )

      const extractNodeTexts = (nodes) =>
        (nodes || []).flatMap(node => {
          const values = (node.values || []).flat()
          if (!values.length) return []
          if (values.every(v => typeof v === 'string')) return values
          return extractNodeTexts(values)
        })
      const docCard = (this.metadataFields || []).find(f => f.id === 'document_card')
      const resumen = ((docCard || {}).values || []).find(f => f.id === 'resumen')
      const metaTexts = extractNodeTexts((resumen || {}).values || [])

      const allTexts = [...paragraphs, ...metaTexts]
      if (!allTexts.length) return concept.terms.length

      return allTexts.reduce((total, text) => {
        const highlighted = filters.highlight(text, terms, false, false)
        const matches = highlighted.match(/<strong class="highlight">/g)
        return total + (matches ? matches.length : 0)
      }, 0)
    },
    conceptsData() {
      return this.conceptsWithTerms().map(concept => ({
        ...concept,
        occurrence_count: typeof concept.terms === 'number'
          ? concept.terms
          : this.countOccurrences(concept)
      }))
    },
    printChart() {
      this.barChart = new TirantBarChart({
        data: this.conceptsData(),
        chartContainer: '#concepts_chart',
        options: {
          horizontal: true,
          custom_colors: true,
          inside_labels: true,
          hide_x: true,
          order: 'value',
          bullet_count: true
        },
        handlers: {
          click: this.handleClick,
          tooltip: this.handleTooltip
        }
      })
      this.barChart.init()
    },
    removePointers() {
      let barElements = Array.from(document.getElementsByClassName('dimple-bar'))
      barElements.forEach( element => {
        element.classList.remove('dimple-bar')
      })

      let labelElements = Array.from(document.getElementsByClassName('inside_label'))
        labelElements.forEach(element => {
          element.style.cursor = 'default'
      })
    },
    async fetchScrTerms() {
      const api = new ApiClient()
      const response = await api.get(
        gon.url_for.scr_terms_concepts_chart_path.replace(':id', this.docid)
      )
      if (response.ok) {
        this.scrData = response.data.semantics
      }
      this.scrLoaded = true
    },
    handleClick(element) {
      if (this.source === 'scr' && !this.scrLoaded) {
        this.loaderVisible = true
        this.clickedElement = element
        return
      }

      if (this.barChart) this.barChart.activateBullet(element.label)
      this.selectConcept(element)
    },
    handleTooltip(element) {
      let text = element['label']

      if(text.length > 40) {
        return this.barChart.tokenizeLargeText(text)
      } else {
        return [text]
      }
    },
    selectConcept(element) {
      var terms = (element.terms || []).flatMap(term => term.split('\n').map(chunked => chunked.trim()).filter(s => s.length > 1))
      var data = { ...element, source: this.source, terms }
      this.initSearch()
      this.setSelectedConcept(data)
      var event = new CustomEvent('concepts:click', { detail: data })
      document.dispatchEvent(event)
    },
    ...mapMutations('document', [
      'initSearch',
      'setSelectedConcept'
    ])
  },
  computed: {
    ...mapState('document', ['headerFields', 'bodyFields', 'metadataFields'])
  },
  async created() {
    if (this.source === 'scr') {
      this.loaderVisible = true
      await this.fetchScrTerms()
      this.mapTermsToConcepts()
      this.printChart()
      this.loaderVisible = false
      this.removePointers()

      if (this.clickedElement) {
        this.selectConcept(this.clickedElement)
      }
    }
  },
  mounted() {
    if (this.source !== 'scr') {
      this.loaderVisible = true
      this.$nextTick(() => {
        this.printChart()
        this.removePointers()
        this.loaderVisible = false
      })
    }
  }
}
</script>
